module.exports = fox._r("images/icon-2.png", __webpack_public_path__ + "images/icon-2.png");


//////////////////
// WEBPACK FOOTER
// ./images/icon-2.png
// module id = 165
// module chunks = 5